import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const getInitialLang = () => {
  if (typeof window === 'undefined') return 'pl';
  return localStorage.getItem('lang') || 'pl';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const toggle = () => setLang(l => {
    const next = l === 'pl' ? 'en' : 'pl';
    localStorage.setItem('lang', next);
    return next;
  });
  return (
    <LanguageContext.Provider value={{ lang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
